<template>
  <div class="evnData" v-if="currentEvnConfiguration.evn">
    <b-row class="evn">
      <b-col md="" sm="12" class="label">
        <slot name="labelEvn">Einzelverbindungsnachweis</slot>
      </b-col>
      <b-col md="" sm="12" class="value"><slot :name="`state${currentEvnConfiguration.evn}`">{{currentEvnConfiguration.evn}}</slot></b-col>
    </b-row>
  </div>
</template>

<script>

import { BCol, BRow } from 'bootstrap-vue'

export default {
  name: 'ShowEvnData',
  props: {
    currentEvnConfiguration: {
      type: Object
    }
  },
  components: {
    'b-row': BRow,
    'b-col': BCol
  }
}
</script>
